module.exports = __webpack_public_path__ + "static/media/w3m.a13a7150.png";